import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/header'
import Footer from '../components/footer'
import Whatsapp from '../components/whatsapp'
import './sobre.css'

const Sobre = () => {
  return (
    <div className="sobre-container">
      <Helmet>
        <title>Sobre - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Conheça a história do Advogado Wanderson H Cavalari, atuando em Cuiabá há mais de 10 anos."
        />
        <meta property="og:title" content="Sobre - Adv. Wanderson H Cavalari - Cuiabá" />
        <meta
          property="og:description"
          content="Conheça a história do Advogado Wanderson H Cavalari, atuando em Cuiabá há mais de 10 anos."
        />
      </Helmet>
      <div className="sobre-wrapper">
        <main className="sobre-main">
          <Header rootClassName="headerroot-class-name-sobre"></Header>
          <div className="sobre-content">
            <div className="sobre-text-block">
              <span className="sobre-title">Wanderson Henrique Cavalari</span>
              <span className="sobre-oab">OAB/MT 21.032</span>
              <span className="sobre-body">
                Com mais de uma década de experiência jurídica, o Dr. Wanderson
                Cavalari atua com seriedade e dedicação na defesa dos interesses
                de seus clientes em Cuiabá e região. Sua formação sólida e
                especializações em áreas estratégicas do direito permitem
                oferecer assessoria precisa e eficaz, em demandas em diversas áreas do direito.
              </span>
              <div className="sobre-credenciais">
                <div className="sobre-credencial-item">
                  <span className="sobre-credencial-label">Graduação</span>
                  <span className="sobre-credencial-valor">Direito, Unic, Universidade de Cuiabá (2014)</span>
                </div>
                <div className="sobre-credencial-item">
                  <span className="sobre-credencial-label">Pós-Graduação</span>
                  <span className="sobre-credencial-valor">Direito Processual Civil</span>
                </div>
                <div className="sobre-credencial-item">
                  <span className="sobre-credencial-label">Pós-Graduação</span>
                  <span className="sobre-credencial-valor">Direito Bancário</span>
                </div>
                <div className="sobre-credencial-item">
                  <span className="sobre-credencial-label">Registro Profissional</span>
                  <span className="sobre-credencial-valor">OAB/MT n.º 21.032</span>
                </div>
              </div>
            </div>
            <img
              alt="Advogado Wanderson Cavalari"
              src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDN8fGxhd3llcnxlbnwwfHx8fDE3MDczMjEyNDZ8MA&ixlib=rb-4.0.3&w=1400"
              className="sobre-image"
            />
          </div>
          <Footer rootClassName="footerroot-class-name-sobre"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default Sobre
